var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-answer-section"},[_c('div',{ref:"answerRef",staticClass:"answers-and-submissions"},[_c('QuestionContent',{attrs:{"result":_vm.dataAnswer,"order":_vm.order,"totalQuiz":_vm.totalQuiz}}),_c(_vm.answerComponentMap[_vm.slideType],{tag:"component",attrs:{"dataAnswer":_vm.dataAnswer}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }